// extracted by mini-css-extract-plugin
module.exports = {"buttonSection":"UpKkW","img":"_3KBZE"};